import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    OnDestroy,
    Output,
} from '@angular/core';
import { CustomDateObject } from '@app/models/Calendar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageService } from '@app/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-dropdown-horizontal-default',
    templateUrl: './dropdown-horizontal.component.html',
    styleUrls: ['./dropdown-horizontal.component.scss'],
})
export class DropdownHorizontalComponent implements OnInit, OnDestroy {
    @Input() data: any[] | any;
    @Input() dates: CustomDateObject | any;
    @Input() selected: any;
    @Input() _i18nKey: string = '';
    @Input() folder: string = '';
    public disabledData: any = [];
    public langSuffix: string = '';

    @Output() selectedItem = new EventEmitter();

    private langSub: Subscription = Subscription.EMPTY;

    constructor(
        private cdRef: ChangeDetectorRef,
        private modalService: NgbModal,
        private languageService: LanguageService,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.initData();
        this.updateLangSuffix(this.languageService.getCurrentLang());

        this.langSub = this.translate.onLangChange.subscribe(({ lang }) => {
            this.updateLangSuffix(lang);
            this.cdRef.detectChanges();
        });
    }

    ngOnDestroy() {
        this.langSub?.unsubscribe();
    }

    private updateLangSuffix(lang: string) {
        this.langSuffix = lang === 'en' ? '_us' : '';
    }

    public initData() {
        if (this.data.length < 4) {
            this.disabledData.push('day');
        }
        if (this.data.length < 3) {
            this.disabledData.push('week');
        }
        if (this.data.length < 2) {
            this.disabledData.push('month');
        }
    }

    public onSelectFormat(selected: any) {
        this.selected = selected;
        this.selectedItem.emit(this.selected);
        this.modalService.dismissAll();
    }

    open(content: any, name: string) {
        this.modalService.open(content, {
            ariaLabelledBy: 'modal-calandar',
            windowClass: 'custom-modal-calendar-' + name,
            animation: false,
        });
    }
}
